module.exports = __webpack_public_path__ + "img/10.6684dd9c.png";